/**
 * Az aktuális árfolyamokat táblázatban megjelenítő komponens
 * @author Erik Banhalmi 2017.05.17.
 */
import aktualisArfolyamTablaTemplate from './aktualis-arfolyam-tabla.pug';
const MODULE_NAME = 'aktualisArfolyamTabla';
class AktualisArfolyamTablaController {
	constructor() {
		'ngInject';
	}
	$onChanges(changeObject) {
		if (!changeObject.aktualis.isFirstChange()) {
			this.aktualisArfolyam = angular.copy(this.aktualis);
		}
	}
}

export default angular.module(MODULE_NAME, [])
	.component('aktualisArfolyamTabla', {
		controller: AktualisArfolyamTablaController,
		template: aktualisArfolyamTablaTemplate(),
		bindings: {
			aktualis: '<'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/aktualis-arfolyamok/aktualis-arfolyam-tabla/aktualis-arfolyam-tabla.js